import { isThereStripeConfiguration } from '@eventbrite/payments';
import {
    StripeElementsAustraliaExperimentVariant,
    StripeElementsCanadaExperimentVariant,
    StripeElementsEuroExperimentVariant,
    StripeElementsNewZealandExperimentVariant,
    StripeElementsUKExperimentVariant,
    StripeElementsUnitedStatesExperimentVariant,
} from '../../constants/statsig/types';
import {
    getAreEventbriteLegacyPaymentMethodsDisabled,
    getIsAppRebrandActive,
    getIsProd,
    getIsStripeElementsInMobileAppEnabled,
    isEventbriteTLD,
    isIosApp,
    isNativeApp,
    isPayinsFlow,
} from '../../selectors/app';
import { getIsTransferredOrder } from '../../selectors/order/getIsTransferredOrder';
import {
    getCurrencyFromOrder,
    isAddAttendeesOrder,
} from '../../selectors/order/typedOrderSelectors';
import { CheckoutState } from '../../state';
import {
    getStripeElementsAustraliaExperimentValue,
    getStripeElementsCanadaExperimentValue,
    getStripeElementsEuroExperimentValue,
    getStripeElementsNewZealandExperimentValue,
    getStripeElementsUKExperimentValue,
    getStripeElementsUnitedStatesExperimentValue,
} from '../../utils/statsig';
import { isStripeConfirmationTokenPaymentMethodAvailable } from './isStripeConfirmationTokenPaymentMethodAvailable';

export const shouldStripeElementsBeAvailable = (state: CheckoutState) => {
    const isNewExperienceEnabled =
        getStripeElementsAustraliaExperimentValue() ===
            StripeElementsAustraliaExperimentVariant.newExperience ||
        getStripeElementsUnitedStatesExperimentValue() ===
            StripeElementsUnitedStatesExperimentVariant.newExperience ||
        getStripeElementsNewZealandExperimentValue() ===
            StripeElementsNewZealandExperimentVariant.newExperience ||
        getStripeElementsCanadaExperimentValue() ===
            StripeElementsCanadaExperimentVariant.newExperience ||
        getStripeElementsUKExperimentValue() ===
            StripeElementsUKExperimentVariant.newExperience ||
        getStripeElementsEuroExperimentValue() ===
            StripeElementsEuroExperimentVariant.newExperience;

    const isCreatorFlow =
        isAddAttendeesOrder(state) ||
        isPayinsFlow(state) ||
        getIsTransferredOrder(state);

    const areEventbriteLegacyPaymentMethodsDisabled =
        getAreEventbriteLegacyPaymentMethodsDisabled(state);

    const nativeApp = isNativeApp(state),
        rebrandActive = getIsAppRebrandActive(state),
        isApplicableByContainer = getIsStripeElementsInMobileAppEnabled(state)
            ? nativeApp || !rebrandActive
            : !nativeApp && !rebrandActive;

    const isLegacyOrExperiment =
        areEventbriteLegacyPaymentMethodsDisabled ||
        (isNewExperienceEnabled && isApplicableByContainer);

    const shouldEnableStripeElementsAccordingToFlow =
        isLegacyOrExperiment &&
        !isCreatorFlow &&
        (isEventbriteTLD(state) || isIosApp(state));

    return (
        shouldEnableStripeElementsAccordingToFlow &&
        isStripeConfirmationTokenPaymentMethodAvailable(state) &&
        isThereStripeConfiguration(
            getCurrencyFromOrder(state),
            getIsProd(state),
        )
    );
};
